import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import { BaseButton, MainButton } from 'components/button/'
import { PairEditorElement } from 'views/slides/activities/matching_pairs/components'

import styles from './pair_editor_component.scss'

class PairEditorComponent extends PureComponent {

	constructor(props) {
		super(props)
		this.savePair = this.savePair.bind(this)
		this.pairAddAnotherHandler = this.pairAddAnotherHandler.bind(this)
		this.changeTextHandler = this.changeTextHandler.bind(this)
		this.newTextHandler = this.newTextHandler.bind(this)
		this.addAnImageHandler = this.addAnImageHandler.bind(this)
		this.changeImageMatrixHandler = this.changeImageMatrixHandler.bind(this)
		this.imageLoadHandler = this.imageLoadHandler.bind(this)
	}

	savePair() {
		if (this.props.canSave) {
			this.props.pairSaveHandler(this.props.clientId)
		}
	}

	pairAddAnotherHandler() {
		if (this.props.canSave) {
			this.props.pairAddAnotherHandler()
		}
	}

	changeTextHandler(value, cardName) {
		this.props.changeTextHandler(value, cardName, this.props.clientId)
	}

	newTextHandler(cardName) {
		this.props.newTextHandler(cardName, this.props.clientId)
	}

	addAnImageHandler(cardName) {
		this.props.addAnImageHandler(cardName, this.props.clientId)
	}

	changeImageMatrixHandler(newMatrix, cardName) {
		this.props.changeImageMatrixHandler(newMatrix, cardName, this.props.clientId)
	}

	imageLoadHandler(width, height, cardName) {
		this.props.imageLoadHandler(width, height, cardName, this.props.clientId)
	}

	render() {
		return (
			<div styleName="AddPairForm">
				<h3 styleName="AddPairForm-title">{this.props.title}</h3>
				<div styleName="AddPairForm-pair">
					<PairEditorElement
						cardName='card1'
						value={this.props.card1}
						imageLoadHandler={this.imageLoadHandler}
						changeImageMatrixHandler={this.changeImageMatrixHandler}
						changeTextHandler={this.changeTextHandler}
						discardContentHandler={this.props.discardContentHandler}
						addAnImageHandler={this.addAnImageHandler}
						newTextHandler={this.newTextHandler}
						pairStatus={this.props.pairStatus['card1']}
					/>
					<PairEditorElement
						cardName='card2'
						value={this.props.card2}
						imageLoadHandler={this.imageLoadHandler}
						changeImageMatrixHandler={this.changeImageMatrixHandler}
						changeTextHandler={this.changeTextHandler}
						discardContentHandler={this.props.discardContentHandler}
						addAnImageHandler={this.addAnImageHandler}
						newTextHandler={this.newTextHandler}
						pairStatus={this.props.pairStatus['card2']}
					/>
				</div>
				<div styleName="AddPairForm-bottom">
					{!!this.props.id && <div styleName="AddPairForm-bottom-deletePairButton">
						<BaseButton
							bgColor="border-blue"
							fontColor="blue"
							onClick={this.props.deletePairHandler}
						>
							{localize('matching_pairs_ct_delete_pair')}
						</BaseButton>
					</div>
					}
					{(this.props.showAddAnotherPair && !this.props.id) &&
						<div styleName="AddPairForm-bottom-addAnotherPairButton">
							<BaseButton
								bgColor="border-blue"
								fontColor="blue"
								onClick={this.pairAddAnotherHandler}
								disabled={!this.props.canSave}
							>
								{localize('matching_pairs_ct_add_another_pair')}
							</BaseButton>
						</div>
					}
					<div styleName="AddPairForm-bottom-done-button">
						<MainButton
							bgColor="blue"
							fontColor="white"
							onClick={this.savePair}
							disabled={!this.props.canSave}
						>
							{localize('matching_pairs_ct_done')}
						</MainButton>
					</div>
				</div>
			</div>
		)
	}

}

export default CSSModules(PairEditorComponent, styles, { allowMultiple: true })
